module.exports = __webpack_public_path__ + "static/media/dark-vr.232832b3.jpg";